import { SupabaseProvider } from '@ad3d/supabase';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import { router } from './router';
import { useAuthStore } from './stores/use-auth-store';
import './styles.css';

registerSW({ immediate: true });

// Initialize auth store
useAuthStore.getState().initialize();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <SupabaseProvider>
      <RouterProvider router={router} />
    </SupabaseProvider>
  </StrictMode>
);
